/**
 * Validates if the provided URL is a valid Slack webhook URL
 */
export function isValidSlackWebhookUrl(url: string): boolean {
  try {
    const urlObj = new URL(url);

    // Check if it's a Slack webhook URL
    return (
      urlObj.protocol === 'https:' &&
      urlObj.hostname === 'hooks.slack.com' &&
      urlObj.pathname.startsWith('/services/')
    );
  } catch {
    return false;
  }
}
